// extracted by mini-css-extract-plugin
export var legendIndicator = "_e0-1";
export var legendRight = "_e0-0";